





































































































































import mixins from 'vue-typed-mixins';
import { BulkHoldRequest } from './BulkHoldRequest';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import BuildEntityListComponentMixin from '@/Shared/CommonEntityMixins/EntityListComponentMixin';
import { AxiosResponse } from 'axios';
import RadioToggle from '@/Shared/RadioToggle.vue';
import VatsAPI from '@/Shared/VatsAPI';

const component = mixins(LocationBasedMixin, BuildEntityListComponentMixin<BulkHoldRequest>()).extend({
    components: {
        RadioToggle
    },
    data() {
        return {
            i18nPrefix: 'admin.bulkHoldRequest',
        };
    },
    computed: {
        entityUrls(): string {
            return `${this.location}/BulkHold/Request`;
        }
    },
    methods: {
        afterSave(response: AxiosResponse<BulkHoldRequest>) {
            response.data.citationsAfter = new Date(response.data.citationsAfter);
            response.data.holdPlacedDate = new Date(response.data.holdPlacedDate);
            response.data.holdReleaseDate = new Date(response.data.holdReleaseDate);
            return response.data;
        },
        afterLoad(response: AxiosResponse<BulkHoldRequest[]>) {
            for (const esc of response.data) {
                esc.citationsAfter = new Date(esc.citationsAfter);
                esc.holdPlacedDate = new Date(esc.holdPlacedDate);
                esc.holdReleaseDate = new Date(esc.holdReleaseDate);
            }
            return response.data;
        },
        async saveRequest(entity: BulkHoldRequest) {
            if (this.editItem?.recID != null) {
                const url = `/${this.location}/bulkhold/update`;
                await VatsAPI.post<BulkHoldRequest>(url, entity);
            }
            else {
                await this.saveEntity(entity);
            }
            await this.loadEntities();
            this.cancelEdit();
        },
        async releaseRequest(entity: BulkHoldRequest) {
            if (entity?.recID != null) {
                const today = new Date();
                entity.holdReleaseDate = today;
                const url = `/${this.location}/bulkhold/update`;
                await VatsAPI.post<BulkHoldRequest>(url, entity);
                this.$bvToast.toast(this.$i18n.t('admin.bulkHoldRequest.refreshSuccessMessage').toString(), {
                    title: this.$i18n.t('common.save').toString(),
                    autoHideDelay: 5000
                });
            }
            await this.loadEntities();
        },
    }
});

export default component;
